import { CONFIG } from "./config";

/** Display-only release gap (seconds) trimmed from a note's tail so consecutive
 *  same-pitch notes visibly separate (and the demo key re-presses). Capped at a
 *  fraction of the note's duration so short/fast notes don't vanish. Pure. */
export function noteTailGapSeconds(durationSeconds: number): number {
  return Math.min(CONFIG.noteGapMs / 1000, durationSeconds * CONFIG.noteGapMaxFraction);
}
